import { render, staticRenderFns } from "./AtrasoJustificadoDetailDialog.vue?vue&type=template&id=eba9c8a8"
import script from "./AtrasoJustificadoDetailDialog.vue?vue&type=script&lang=js"
export * from "./AtrasoJustificadoDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports